import styled from "styled-components";

export default styled.th`
  color: #484848;
  font-weight: normal;
  padding: 1rem;
  max-width: 106px;
`;
